const ManageNotifications = () => {
  return null
}

export default ManageNotifications
